module.exports={select:"選取",selected:"已選取"};